import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router';


// const service = axios.create({})

// request interceptor
axios.interceptors.request.use(
  config => {
    let sessionUser = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage.getItem('userData');
    let sessionUserData = JSON.parse(sessionUser);
    (sessionUserData && sessionUserData.token) ? config.headers['AuthToken'] = sessionUserData.token : "";
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return error
  }
)

// response interceptor
axios.interceptors.response.use(
  response => {
    const res = response.data;
    // console.log('进这里-----response-----', res)
    if (res.code) {
      if (res.code === 10403) {
        router.push("/401")
      } else if (res.code === 10404 || res.code === 10405 || res.code === 100101 || res.code === 10010 || res.code === 100102) {
        Message({
          message: res.msg,
          type: 'warning',
          duration: 5 * 1000
        })
        router.push("/login")
      } else if (res.code == 100100) {
        tokentext = "用户令牌缺失，请重新登录";
        Message.error(tokentext);

      } else if (res.code == 100101) {
        tokentext = "用户令牌无效，请重新登录";
        Message.error(tokentext);
      } else if (res.code == 10010) {
        tokentext = "您的账号已在别处登录，如要继续使用请重新登录";
        Message.error(tokentext);
      } else if (res.code == 100102) {
        tokentext = "用户令牌已过期，如要继续使用请重新登录";
        Message.error(tokentext);
      } else if (res.code == 204) {
        window.loadingFun(false);
        Message.error('访问过于频繁，如需继续访问，可联系我们。');
        return;
      } else {
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return res
    } else {
      return res
    }
  },
  error => {
    //  console.log('进这里---error-----', error)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return error
  }
)

export default axios